var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2003,
    cy: 12.3013,
    r: 11.7003,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.707 8.10115C13.9745 6.30727 11.1655 6.30727 9.43303 8.10115C9.02168 8.52416 8.69482 9.02945 8.47166 9.58734C8.2485 10.1452 8.13354 10.7444 8.13354 11.3497C8.13354 11.9551 8.2485 12.5543 8.47166 13.1122C8.69482 13.67 9.02168 14.1753 9.43303 14.5983L12.5697 17.8469L15.707 14.5983C16.1184 14.1753 16.4452 13.67 16.6684 13.1122C16.8916 12.5543 17.0065 11.9551 17.0065 11.3497C17.0065 10.7444 16.8916 10.1452 16.6684 9.58734C16.4452 9.02945 16.1184 8.52416 15.707 8.10115ZM12.5697 12.885C12.1993 12.885 11.8516 12.7332 11.5892 12.4577C11.3296 12.1838 11.1837 11.8126 11.1837 11.4256C11.1837 11.0387 11.3296 10.6675 11.5892 10.3936C11.851 10.118 12.1993 9.96625 12.5697 9.96625C12.9402 9.96625 13.2885 10.118 13.5503 10.3936C13.8099 10.6675 13.9558 11.0387 13.9558 11.4256C13.9558 11.8126 13.8099 12.1838 13.5503 12.4577C13.2885 12.7332 12.9402 12.885 12.5697 12.885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.a1d6307a95be2f1c560617a6c98d1e7e.svg";
export { ForwardRef as ReactComponent };